import { List as AntList, GetProps } from 'antd';

export const List = AntList;

export type ListProps = GetProps<typeof AntList>
